<template>
    <select class="form__field" v-model="selectedValue" @change="updateInput">
        <option v-for="language in languages" :key="language.value" :label="language.label" :value="language.value">
            {{ language.label }}
        </option>
    </select>
</template>

<script>
export default {
    name: 'language-select',
    props: {
        preselectedValue: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            languages: [
                {
                    value: 'en',
                    label: 'English',
                },
                {
                    value: 'de',
                    label: 'Deutsch',
                },
                {
                    value: 'fr',
                    label: 'Français',
                },
                {
                    value: 'it',
                    label: 'Italiano',
                },
            ],
            selectedValue: '',
        };
    },
    created() {
        this.selectedValue = this.preselectedValue;
    },
    methods: {
        updateInput() {
            setTimeout(() => {
                this.$emit('input', this.selectedValue);
            }, 100);
        },
        updatePreselectedValue(value) {
            this.selectedValue = value;
        },
    },
};
</script>
